'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var alignSelfValues = exports.alignSelfValues = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  auto: 'auto'
};

var getAlignSelf = exports.getAlignSelf = function getAlignSelf(val) {
  return alignSelfValues[val] || 'auto';
}; // Column mixins


var align = exports.align = function align(val) {
  return '\n  align-self: ' + getAlignSelf(val) + ';\n';
};

var order = exports.order = function order(index) {
  return '\n  order: ' + index + ';\n';
};

var span = exports.span = function span(size, fixed) {
  return '\n  flex-basis: ' + (fixed ? 1 : size) + ';\n  max-width: ' + size + ';\n';
};

var grow = exports.grow = function grow(size) {
  return '\n  width: auto;\n  max-width: none !important;\n  flex-grow: ' + size + ';\n';
};

var shrink = exports.shrink = function shrink(size) {
  return '\n  width: auto;\n  max-width: none !important;\n  flex-shrink: ' + size + ';\n';
};

var offset = exports.offset = function offset(offsetVal) {
  return '\n  position: relative;\n  margin-left: ' + offsetVal + ';\n  ';
};

var gutter = exports.gutter = function gutter(gutterVal) {
  return '\n  padding-right: ' + gutterVal + ';\n  padding-left: ' + gutterVal + ';\n  ';
};

var gutterless = exports.gutterless = function gutterless() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return val ? '\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  ' : null;
};

var hidden = exports.hidden = function hidden(val) {
  return val ? 'display: none;' : 'display: block;';
};

var position = exports.position = function position() {
  var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'static';
  return 'position: ' + pos + ';';
}; // Row mixins


var justifyValues = exports.justifyValues = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  around: 'space-around',
  between: 'space-between',
  evenly: 'space-evenly',
  normal: 'normal',
  initial: 'initial'
};

var justify = exports.justify = function justify(val) {
  return '\n  justify-content: ' + (justifyValues[val] || 'normal') + ';\n  ';
};

var directionValues = exports.directionValues = {
  column: 'column',
  columnReverse: 'column-reverse',
  row: 'row',
  reverse: 'row-reverse',
  unset: 'unset',
  initial: 'initial'
};

var direction = exports.direction = function direction(val) {
  return '\n  flex-direction: ' + (directionValues[val] || 'row') + ' !important;\n  ';
};

var alignValues = exports.alignValues = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center'
};

var rowWidth = exports.rowWidth = function rowWidth(val, fullWidth) {
  return !fullWidth && 'max-width: ' + val + 'px;';
};

var alignColumns = exports.alignColumns = function alignColumns(val) {
  return '\n  align-items: ' + (alignValues[val] || 'normal') + ';\n  ';
};

var debug = exports.debug = function debug() {
  return '\n  background: line-gradient(from left, red 0, red 100%);\n';
};

var center = exports.center = function center(val) {
  return '\n  margin: ' + (val && '0 auto') + ';\n';
};

var sideMargin = exports.sideMargin = function sideMargin(val) {
  return '\n  width: calc(100% - ' + val + ');\n  padding-left: 0 ' + val + ';\n  padding-right: 0 ' + val + ';\n  ';
};